import React from "react";
import { twMerge } from "tailwind-merge";
import type { ControlPosition } from "./utils";
import { getControlPositionClasses } from "./utils";

export interface ControlBaseProps {
  position?: ControlPosition;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

/**
 * Base component for map controls - handles positioning and container styling
 *
 * This is the foundation component for all map controls. It provides:
 * - Consistent positioning in map corners (top-left, top-right, bottom-left, bottom-right)
 * - Z-index management for proper layering
 * - Custom style override capability
 *
 * Use this component when creating new map controls to ensure consistent positioning.
 *
 * @example
 * <ControlBase position="top-right">
 *   <Button>My Control</Button>
 * </ControlBase>
 */
export function ControlBase({ position = "top-right", className, style, children }: ControlBaseProps) {
  return (
    <div className={twMerge(getControlPositionClasses(position), className)} style={style}>
      {children}
    </div>
  );
}
